import { render, staticRenderFns } from "./TabLabels.vue?vue&type=template&id=49d19838"
import script from "./TabLabels.ts?vue&type=script&lang=ts&external"
export * from "./TabLabels.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports